<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>Conversion</h2>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>

    <main id="cont" class="product_cubeone">
      <div id="overview" class="subCon inner_box">
        <section class="platform1" id="about">
          <h3 class="con_tit">About Conversion</h3>
          <div class="img">
            <v-img
              src="@/assets/img/conversion/about/about_img1.svg"
              alt=""
              style="
                border-radius: 8px;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                  0 6px 20px 0 rgba(0, 0, 0, 0.19);
                margin: 0 auto;
                max-width: 70%;
              "
            />
          </div>

          <div class="con">
            <p style="font-size: 20px">
              Conversion 솔루션은 크게 AS-IS 시스템 분석 솔루션, <br />서버
              컨버전 솔루션, 데이터베이스 교체 시 컨버전 솔루션, <br />그리고
              프로그램 언어 변환 컨버전 솔루션으로 이루어져 있습니다.
            </p>
            <p style="font-size: 20px">
              Conversion 솔루션의 프로세스 과정은 <br />자원 수집, 자원 분석,
              전환 룰 추출 및 등록 <br />그리고 전환 검증 단계로 이루어져
              있습니다.
            </p>
          </div>
        </section>

        <br />

        <div class="subCon serviceCon">
          <section id="onwatch">
            <h3 class="con_tit">SmartAnalyzer™</h3>

            <div class="txtBox">
              <div class="inner_box">
                <dl>
                  <dt>SmartAnalyzer™</dt>
                  <dd>
                    현행 시스템 정보와 변환을 위한 정보를 분석하여
                    <br />일목요연하게 현황을 보여주고 산출물을 자동화하는
                    컨버전솔루션입니다.<br />
                  </dd>
                </dl>
              </div>
            </div>
          </section>
          <section class="subsc iconLst inner_box">
            <h4 class="con_subtit">도입 기대 효과</h4>
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10 landing-warpper text-center"
              rounded
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="3">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/conversion/analyzer/service_icon1-3.png"
                        alt=""
                        style="margin: 0 auto; max-width: 50%"
                      />
                      <dl>
                        <br />
                        <dt style="font-size: 20px">
                          프로젝트 전 현행 시스템<br />
                          상세 분석
                        </dt>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="3">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/conversion/analyzer/service_icon1-4.png"
                        alt=""
                        style="margin: 0 auto; max-width: 50%"
                      />
                      <dl>
                        <br />
                        <dt style="font-size: 20px">
                          소프트웨어 현황 상세 분석
                        </dt>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="3">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/conversion/analyzer/service_icon1-5.png"
                        alt=""
                        style="margin: 0 auto; max-width: 50%"
                      />
                      <dl>
                        <br />
                        <dt style="font-size: 20px">프로젝트 수행 능력 향상</dt>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="3">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/conversion/analyzer/service_icon1-8.png"
                        alt=""
                        style="margin: 0 auto; max-width: 50%"
                      />
                      <dl>
                        <br />
                        <dt style="font-size: 20px">
                          분석 및 설계문서 자동 출력
                        </dt>
                      </dl>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </section>
        </div>
        <br /><br /><br /><br /><br /><br />
        <div class="subCon bsnCon">
          <section id="SmartFresh">
            <h3 class="con_tit">Server Conversion (SmartFresh™)</h3>

            <section class="summary">
              <div class="inner_box clearfix">
                <div class="img">
                  <v-img
                    src="@/assets/img/conversion/business/bsn_img4-3.jpg"
                    alt=""
                    style="height: 300px; margin: 0 auto; margin-bottom: 200px"
                  />
                </div>
                <div class="txt">
                  <big>
                    <em>서버 교체</em> 혹은 <em>업그레이드</em> 시<br />기존
                    운영체제에서 실행되는 어플리케이션을 <br />
                    새로운 운영체제 위에서 실행되도록 환경을 <br />자동적으로
                    맞출 수 있습니다.</big
                  >
                  <span class="dot"><span></span></span>
                  <p>
                    SmartFresh™는 분석 완료된 소스에 대한 자동 변환을 수행하는
                    도구입니다.<br />
                    현행 시스템 분석 도구를 통해 분석한 가이드를 바탕으로 작성된
                    Rule을 적용하여 자동 변환합니다.
                  </p>
                </div>
              </div>
            </section>
            <section class="con inner_box" id="SmartFresh">
              <h4>SmartFresh™ 도입 이점</h4>
              <ul class="imgLst item3">
                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img1-1.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>안전성과 효율성</dt>
                    <dd>
                      휴먼 에러 감소, 소스의 통일성 및 직관성 증대로
                      <br />유지관리 효율성 증대
                    </dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img1-2.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>리스크 관리</dt>
                    <dd>
                      문제 사전 파악과 다각적 영향 분석을 통해<br />리스크
                      최소화 가능
                    </dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img1-3.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>시간과 비용 절약</dt>
                    <dd>
                      마이그레이션 시간 및 테스트 단계 단축으로<br />비용절감
                    </dd>
                  </dl>
                </li>
              </ul>
            </section>
          </section>
          <!-- #brand -->

          <section id="SmartBlue">
            <h3 class="con_tit">Database Conversion (SmartBlue™)</h3>

            <section class="summary">
              <div class="inner_box clearfix">
                <div class="img">
                  <v-img
                    src="@/assets/img/conversion/business/bsn_img4-0.jpg"
                    alt=""
                    style="width: 624px; height: 496px; margin: 0 auto"
                  />
                </div>

                <div class="txt">
                  <big
                    ><em>데이터베이스 이전</em> 및 <em>업그레이드</em>시<br />
                    새로운 데이터베이스에 맞게<br />소스코드(Pro*C, SQL, DB
                    Object) <br />를 자동으로 전환할 수 있습니다.</big
                  ><span class="dot"><span></span></span>
                  <p style="margin: 0">
                    SmartBlue™는 강력한 변환 룰 엔진으로 다양한 DBMS를
                    지원합니다.<br />
                    또한 데이터베이스 분석 정보 및 SQL 관리 기능을
                    제공합니다.<br />
                  </p>
                </div>
              </div>
            </section>
            <section class="con inner_box">
              <h4>SmartBlue™ 도입 이점</h4>

              <ul class="imgLst item3">
                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img3-2.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>지식 데이터베이스 화</dt>
                    <dd>데이터베이스 변환 지식 데이터베이스 화</dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img2-2.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>정보 메타화</dt>
                    <dd>
                      데이터베이스 관리 정보를 메타화하여 유지보수에 활용<br />
                      또한 변환 전후 데이터베이스 및 프로그램 정보 확인
                    </dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img2-3.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>시간과 비용 절약</dt>
                    <dd>데이터베이스 변환 시 비용 및 기간 단축(40~50%)</dd>
                  </dl>
                </li>
              </ul>
            </section>
          </section>

          <section id="SmartBridge">
            <h3 class="con_tit">Application Conversion (SmartBridge™)</h3>

            <section class="summary">
              <div class="inner_box clearfix">
                <div class="img">
                  <v-img
                    src="@/assets/img/conversion/business/case_img6-1.jpg"
                    alt=""
                    style="width: 500px; height: 430px; margin-bottom: 120px"
                  />
                </div>

                <div class="txt">
                  <big
                    >기존 프로그램 언어로 작성된 소스를 <br />
                    <em>새로운 프로그램 언어</em>로 변환합니다.<br />
                    또한 다양한 어플리케이션 프레임워크에 맞는 <br />시스템 변환
                    기능도 제공합니다.<br />
                  </big>
                  <span class="dot"><span></span></span>

                  <p>
                    C, C++, C#, Java, Shell, COBOL, PL/I, Assembler, VisualGen,
                    Power Builder 등<br />
                    다양한 프로그래밍 언어를 지원합니다.<br />
                    또한 Nexcore, DevOn, AnyFrame, BANCS, Proframe, ADF,
                    Systemier 등 <br />
                    여러 어플리케이션 프레임워크를 지원합니다.<br />
                  </p>
                </div>
              </div>
            </section>
            <section class="con inner_box">
              <h4>SmartBridge™ 도입 이점</h4>

              <ul class="imgLst item3">
                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/service_img1-3.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>정확한 현행시스템 자원 분석</dt>
                    <dd>차세대 시스템 개발 프로젝트에 활용할 수 있습니다.</dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/service_img3-2.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>신규 시스템 병행 관리</dt>
                    <dd>
                      시스템 아케텍처 및 프레임워크 관리 업무에 활용할 수
                      있습니다.
                    </dd>
                  </dl>
                </li>

                <li>
                  <div class="img">
                    <v-img
                      src="@/assets/img/conversion/business/bsn_img3-3.jpg"
                      alt=""
                    />
                  </div>
                  <dl>
                    <dt>개발 리스크 감소</dt>
                    <dd>
                      이와 함께 수작업 대비 기간을 단축할 수 있으며<br />
                      전환 대상이 많을 수록 더 큰 효과를 기대할 수 있습니다.
                    </dd>
                  </dl>
                </li>
              </ul>
            </section>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
